import { ParamMap } from '@angular/router';
import {
    DashboardScope,
    IDashboardOptions,
    WidgetResource,
} from '@pages/monitoring/types';

export const extractDashboardOptions = (query: ParamMap): IDashboardOptions => ({
    resource: query.get('resource') as WidgetResource,
    scope: query.get('entityId') != null ? DashboardScope.Entity : DashboardScope.Global,
});
